/* import __COLOCATED_TEMPLATE__ from './comparison-statistic.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();